import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { dateService } from '../../../services/date';

import SingleDayPicker from '../../base/date/single-date-picker';

import './strategy-date-picker.scss';

const StrategyDatePicker = ({ datetimeStart, datetimeEnd, updateStrategy, setError }) => {
  const [didMount, setDidMount] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: datetimeStart ? moment(datetimeStart).utc() : null,
    endDate: datetimeEnd ? moment(datetimeEnd).utc() : null,
  });

  const expired = !!(dateRange.endDate && dateRange.startDate > dateRange.endDate);
  const dateRangeMap = { startDate: 'datetime_start', endDate: 'datetime_end' };

  useEffect(() => {
    setDidMount(true);
  }, []);

  useEffect(() => {
    if (didMount) {
      setError({
        startDate: !dateRange.startDate,
        date: !!(dateRange.endDate && dateRange.startDate > dateRange.endDate),
      });
    }
  }, [dateRange]);

  function updateDate(key, date) {
    const isValidDate = moment(date).isValid();
    const utcDate = isValidDate ? date.utc() : null;
    const startOrEndOfDay = utcDate
      ? key === 'startDate'
        ? utcDate.startOf('day')
        : utcDate.endOf('day')
      : null;
    const utcDateTime = isValidDate ? dateService.toIso8601UtcDatetime(startOrEndOfDay) : null;

    updateStrategy({
      [dateRangeMap[key]]: isValidDate ? utcDateTime : null,
    });

    setDateRange({
      ...dateRange,
      [key]: isValidDate ? utcDate : null,
    });
  }

  const expiredError = expired ? <span className="expired">Expired</span> : null;

  return (
    <div className="date-input-container">
      <span className="date-start-label">Date</span>
      <SingleDayPicker
        id="start-date"
        placeholder="Start Date"
        date={dateRange.startDate}
        setDate={date => updateDate('startDate', date)}
        error={expired}
      />
      <span className="to">to</span>
      <SingleDayPicker
        id="end-date"
        placeholder="End Date"
        date={dateRange.endDate}
        setDate={date => updateDate('endDate', date)}
        error={expired}
      />
      <div className="tags">
        {expiredError}
        <span className="optional">Optional</span>
      </div>
    </div>
  );
};

export default StrategyDatePicker;
